import { render } from "./InteligenciaArtificial.vue?vue&type=template&id=031451c9&scoped=true"
import script from "./InteligenciaArtificial.vue?vue&type=script&lang=js"
export * from "./InteligenciaArtificial.vue?vue&type=script&lang=js"

import "./InteligenciaArtificial.vue?vue&type=style&index=0&id=031451c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031451c9"]])

export default __exports__